
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { UseFormReturn, useFormState } from "react-hook-form"
import { FormValues } from "../schema"
import { useEffect } from "react"

interface DonationFieldProps {
  form: UseFormReturn<FormValues>
  membershipType: "active" | "benefactor" | "donor"
}

export function DonationField({ form, membershipType }: DonationFieldProps) {
  const { errors } = useFormState({ control: form.control });
  
  // Effect to clear validation errors when switching from donor to other membership types
  useEffect(() => {
    if (membershipType !== "donor") {
      // Clear donation-related errors when not in donor mode
      if (errors.additionalDonation) {
        form.clearErrors("additionalDonation");
      }
    } else if (membershipType === "donor") {
      // Only validate for donor type
      const currentDonation = form.getValues("additionalDonation");
      if (currentDonation === 0) {
        form.trigger("additionalDonation");
      }
    }
  }, [membershipType, form, errors.additionalDonation]);

  return (
    <FormField
      control={form.control}
      name="additionalDonation"
      render={({ field }) => (
        <FormItem className="rounded-lg bg-gradient-to-br from-background to-secondary/5 p-6">
          <FormLabel className="text-xl font-semibold">
            {membershipType === "donor" ? "Montant du don" : "Don supplémentaire"}
          </FormLabel>
          <FormControl>
            <Input 
              type="number" 
              min="0"
              placeholder="0"
              value={field.value === 0 ? "" : field.value}
              onChange={e => {
                const value = e.target.value === '' ? 0 : Number(e.target.value);
                field.onChange(value);
                
                // Trigger validation immediately for donor type
                if (membershipType === "donor") {
                  setTimeout(() => form.trigger("additionalDonation"), 100);
                }
              }}
              className="bg-background text-lg mt-2"
              aria-invalid={membershipType === "donor" && field.value === 0}
            />
          </FormControl>
          <FormDescription className="text-sm mt-2">
            {membershipType === "donor" 
              ? "Veuillez entrer le montant de votre don"
              : "Vous pouvez ajouter un don supplémentaire à votre adhésion pour soutenir davantage notre action"
            }
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
